import React, {useState, useEffect} from "react";
import { Link, useNavigate } from 'react-router-dom'
import { athletDashboardURL } from "../../apis/urls";
import axios from "axios";
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities"; 
import { FallingLines } from 'react-loader-spinner'


const DashboardAthletic = () => {


    useEffect( ()=> {
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        ApproveListing();
    },[])

    let navigate = useNavigate()


    let role = localStorage.getItem('userrole');

    // console.log("role", role)




    const [result, setResult] = useState([]); 
    const [loader, setLoader] = useState(true);  
  

    let token = "Bearer "+localStorage.getItem('token');

    const ApproveListing = () => {
         
        const instance = axios.create({

            baseURL: athletDashboardURL,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setResult(response.data.data);
            setLoader(false)


            console.log(response.data.data)
          }).catch((error) =>{

            
            localStorage.removeItem('token')
    
            navigate("/")

            console.log('error',error.message)
            
          });

    }


    let sl=1;

    let newarr =0;
    let uparr =0;
    let inarr =0;
    let apparr =0;

    return( 
        <div className="dashboard">
            <aside class="right-side areas">
                <div class="content-area dash-contentss">
                <div>

                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <h2 class="page-title"> Dashboard - Athletic Eligibility  </h2>
                        </div>
                    </div>


                    {!loader?

                        <div class="container">


                            <table class="table table-rules">
                                <thead>
                                    <tr className="rules-table-head">
                                    <th scope="col">Sl.No</th>
                                    <th scope="col">School Name</th>
                                    <th scope="col">New AE</th>
                                    <th scope="col">Update AE</th>
                                    <th scope="col">Ineligible by HOS</th>
                                    <th scope="col">Approved by GISA</th>
                                    <th scope="col" style={{textAlign:'center'}}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="rules-table-content">
                                {
									result?.map((item,index) =>(

                                        <tr >
                                            <td>{sl++}</td>
											<td>{decode(item.schoolname)}</td>
                                            <td>
                                                <Link  to={"/new_athletic_dashboard/"+newarr++} style={{color:'#000'}} data-toggle="tooltip" title="New Athletic Eligibility">
                                                    {item.createdCount=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.createdCount}
                                                </Link>
                                            </td>
                                            <td>
                                                <Link  to={"/updated_athletic_dashboard/"+uparr++} style={{color:'#000'}} data-toggle="tooltip" title="Updated Athletic Eligibility">
                                                    {item.updatedCount=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.updatedCount}
                                                </Link>
                                            </td>

                                            <td>
                                                <Link  to={"/ineligible_athletic_dashboard/"+inarr++} style={{color:'#000'}} data-toggle="tooltip" title="Ineligible Athletic Eligibility">
                                                    {item.inligibleCount=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.inligibleCount}
                                                    
                                                </Link>
                                            </td>
                                            <td>
                                                <Link  to={"/approved_athletic_dashboard/"+apparr++} style={{color:'#000'}} data-toggle="tooltip" title="Approved Athletic Eligibility">
                                                    {item.gisaApprovedCount=== 0?<button disabled style={{background:'transparent'}}>0</button>:item.gisaApprovedCount}
                                                </Link>
                                            </td>
                                            <td>
                                                <div className="list-action-wrpr showicons roundicons-text">
                                                    <div className="list-action-wrpr">
                                                    <Link  to={"/school_list/athlet_list/"+item.schoolsid} data-toggle="tooltip" title="View">
                                                        <i class="view icon-eye"></i>
                                                        <span>View All</span>
                                                    </Link>
                                                    </div>
                                                </div>
                                            </td>
                                        
                                        </tr>
                                    ))
                                }
                                
                                </tbody>
                            </table>
                        </div>:

                        
                    <div class="container" style={{alignItems:'center', marginLeft:'45%', marginTop:'20%'}}>
                    <div className="fp-container">
                        <FallingLines
                            color="#fff"
                            width="50"
                            visible={true}
                            ariaLabel='falling-lines-loading'
                            />
                    </div>
                    </div>

                    }            

                    </div>
                </div>
            </aside>
        </div>
    )
};

export default DashboardAthletic;
